import { fourFeatures } from '@/mocks/aboutData';
import { useTranslation } from 'react-i18next';

export default function FourFeatures() {
  const { t } = useTranslation();
  const featureKeys = [
    { title: 'about.features.1.title', desc: 'about.features.1.desc', icon: fourFeatures[0].icon },
    { title: 'about.features.2.title', desc: 'about.features.2.desc', icon: fourFeatures[1].icon },
    { title: 'about.features.3.title', desc: 'about.features.3.desc', icon: fourFeatures[2].icon },
    { title: 'about.features.4.title', desc: 'about.features.4.desc', icon: fourFeatures[3].icon },
  ];
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            OUR STRENGTHS
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('about.features.title')}
          </h2>
          {String(t('about.features.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('about.features.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {featureKeys.map((feature, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 p-6 md:p-8 flex flex-col items-start cursor-default"
            >
              <div className="w-12 h-12 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-accent-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
                {t(feature.title)}
              </h3>
              {String(t(feature.desc)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed">{__s}</p>))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}